<template>
    <div class="page-container">
        <el-row>
            <el-col :span="24">
                <el-form :inline="true" :model="queryForm" @keyup.enter.native.prevent="fetchData()"
                    class="demo-form-inline toolbar" style="padding-bottom: -10px">
                    <el-form-item label="设备编号:">
                        <el-input v-model="deviceNo" readonly />
                    </el-form-item>
                    <el-form-item label="时间范围:" style="margin-left: 10px">
                        <el-date-picker :editable="false" v-model="queryForm.timevalue" unlink-panels type="daterange"
                            start-placeholder="开始时间" end-placeholder="结束时间" value-format="yyyy-MM-dd HH:mm:ss"
                            clearable></el-date-picker>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-search" plain
                            @click.native.prevent="fetchData">查询</el-button>
                    </el-form-item>
                </el-form>
            </el-col>
            <el-col v-loading="loading">
                <el-tabs v-model="activeName"  type="card" @tab-click="handleClick">
                    <el-tab-pane label="实时定位" name="first">
                        <div class="oldmanmap">
                            <div id="container" ref="amap" class="map"></div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="历史轨迹" name="second">
                        <div class="oldmanmap">
                            <div id="historymap" ref="hamap" class="map"></div>
                        </div>
                    </el-tab-pane>
                    <el-tab-pane label="定位记录" name="third">
                        <table-base
                          :tableData="logList"
                          @page-change="pageChange"
                          :len="tabelLen"
                          :pageNum="pageNum"
                          :pageSize="pageSize">
                          <template slot="table">
                            <el-table-column prop="lbsType" align="center" label="定位方式">
                              <template slot-scope="scope">
                                <span v-if="scope.row.lbsType == 1">gps定位</span>
                                <span v-else-if="scope.row.lbsType == 2">基站定位</span>
                                <span v-else-if="scope.row.lbsType == 3">wifi定位</span>
                                <span v-else>其他</span>
                              </template>
                            </el-table-column>
                            <el-table-column prop="gpsString" align="center" label="经纬度" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="location" align="center" label="位置信息" show-overflow-tooltip>
                            </el-table-column>
                            <el-table-column prop="locationTime" align="center" label="时间" width="180">
                            </el-table-column>
                          </template>
                        </table-base>
                    </el-tab-pane>
                </el-tabs>
            </el-col>
        </el-row>
    </div>
</template>
<script>
import AMapLoader from '@amap/amap-jsapi-loader'
import service_loc from "@/assets/map/service_loc.png";
import old_loc from "@/assets/map/oldman_marker.png";
import TableBase from "@/components/common-table";
export default {
    name: 'DeviceLocationPage',
    components: { TableBase },
    props: {
        deviceNo: {
            type: String,
            required: true
        },
        deviceId:{
            type: String,
            required: true
        }
    },
    data() {
        return {
            queryForm: {
                timevalue: '',
            },
            loading:true,
            activeName:'first',
            historyList:[],
            dayList: [],
            logList:[],
            tabelLen:0,
            pageNum: 1,
            pageSize: 10,
            AMap:null,
            map:null,
            secondMap:null,
            center:[],
            gpsString:"",
            location:"",
            locationTime:"",
            lbsType:"gps",
        }
    },
    watch: {
        deviceNo(newVal, oldVal) {
            this.deviceNo = newVal;
            this.fetchData();
        }
    },
    methods: {
        handleClick(tab, event){
            console.log(tab);
            if(tab.name == 'second'){
                if(this.secondMap == null){
                    this.initSecondMap();
                }
            }
        },
        initSecondMap(){
            let _this = this;
            AMapLoader.load({
              key: 'bb369d6617c417b4826cee55ac7ad116',
              version: '2.0',
              plugins: []
            }).then((AMap) => {
              //服务人员定位
              let map = new AMap.Map('historymap', {
                  zoom: 15, // 初始化地图级别
                  zooms: [5, 30], // 地图缩放范围
                  // 可以设置初始化当前位置
                  center: _this.center
              })
              _this.secondMap = map;
              _this.historyList.forEach(item=>{
                let marker = new AMap.Marker({
                  position: item,
                  icon: new AMap.Icon({            
	                      image: old_loc,
	                      size: new AMap.Size(32, 32),  //图标所处区域大小
	                      imageSize: new AMap.Size(32,32) //图标大小
	                }),
                  offset: new AMap.Pixel(-16, -32)
                });
                marker.setMap(map);
                map.add(marker)
              })
            })
        },
        initMap() {
            let _this = this;
            console.log(_this.center);
            AMapLoader.load({
              key: 'bb369d6617c417b4826cee55ac7ad116',
              version: '2.0',
              plugins: []
            }).then((AMap) => {
              //服务人员定位
              let map = new AMap.Map('container', {
                  zoom: 15, // 初始化地图级别
                  zooms: [5, 30], // 地图缩放范围
                  // 可以设置初始化当前位置
                  center: _this.center
              })
              let marker = new AMap.Marker({
                  position: _this.center,
                  icon: new AMap.Icon({            
	                      image: service_loc,
	                      size: new AMap.Size(32, 32),  //图标所处区域大小
	                      imageSize: new AMap.Size(32,32) //图标大小
	                }),
                  offset: new AMap.Pixel(-16, -32)
              });
              marker.setMap(map);
              map.add(marker)
            })
        },
        getRealData(){
            let deviceId=this.deviceId
            this.$postForm('dmc/watch/queryRealLocationByDeviceId/'+deviceId).then(res => {
                console.log(res);
                if(res.result != null){
                  console.log(res.result.gpsString.split(','))
                  let lat=res.result.gpsString.split(',')[1];
                  let lng=res.result.gpsString.split(',')[0];
                  let wgs = [Number(lat), Number(lng)];
                  wgs[0] = wgs[0] + 0.0055;
                  wgs[1] = wgs[1] - 0.0025;
                  this.center = wgs;
                  this.gpsString=res.result.gpsString;
                  this.location=res.result.location;
                  this.locationTime=res.result.locationTime;
                  if(res.result.lbsType==1){
                    this.lbsType='gps'
                  }else if(res.result.lbsType==2){
                    this.lbsType='lbs'
                  }else{
                     this.lbsType='wifi'
                  }
                  this.initMap();
                }else{
                  this.$message({
                    message:'暂无定位信息',
                    type:'warning'
                  })
                }
               
            });
        },
        fetchData() {
            //
            let param = {
                deviceId: this.deviceId,
                pageNum: this.pageNum,
                pageSize: 10,
            };
            this.loading = true;
            this.$postJson("dmc/watch/queryHistLocationListWithPage", param).then(res => {
                console.log(res);
                this.logList = res.result.list;
                this.tabelLen = res.result.total * 1;
                this.loading = false;
            });
        },
        getHistoryList() {
            let param = {
                deviceId: this.deviceId,
                pageNum: 1,
                pageSize: 199,
            };
            this.$postJson("dmc/watch/queryHistLocationListWithPage", param).then(res => {
                console.log(res);
                let historyList = [];
                res.result.list.forEach(item=>{
                    let lat=item.gpsString.split(',')[1];
                    let lng=item.gpsString.split(',')[0];
                    let wgs = [Number(lat), Number(lng)];
                    wgs[0] = wgs[0] + 0.0055;
                    wgs[1] = wgs[1] - 0.0025;
                    historyList.push(wgs);
                })
                this.historyList = historyList;
                console.log(historyList);
            });
        },
        pageChange(val){
            this.pageNum = val;
            this.fetchData();
        },
    },
    mounted() {
        console.log("mounted");
        // this.initMap();
        this.getRealData();
        this.getHistoryList();
        this.fetchData();
    }
}
</script>
<style lang="scss" scoped>
.page-container{
    margin-top: -25px;
}
table {
    margin: 30px 5px;
    border-collapse: collapse;
    border: 1px solid #cccccc;
}

td {
    border: 1px solid #cccccc;
}

img {
    cursor: pointer;
}

.oldmanmap {
    margin: 0px;
    .map {
      width: 100%;
      height: 58vh;
    }
  }
</style>
